import { render, staticRenderFns } from "./AnalysisExportWork.vue?vue&type=template&id=00afe43b&scoped=true"
import script from "./AnalysisExportWork.vue?vue&type=script&lang=ts"
export * from "./AnalysisExportWork.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00afe43b",
  null
  
)

export default component.exports